import { JBEnvironmentId } from '@juliusbaer-gcrm/gcrm-frontend-components';

export const getEnv = (env: JBEnvironmentId) => {
  const mergeRequestIid = import.meta.env.VITE_CI_MERGE_REQUEST_IID;
  switch (env) {
    case 'LOCAL': {
      return 'http://localhost:3000/remoteEntry.js';
    }
    case 'SANDBOX': {
      return 'https://pcc-contact-note-frontend.pcm-sandbox.gcrm.sehlat.io/remoteEntry.js';
    }
    case 'DEV': {
      return `https://pcc-contact-note-frontend-pre-pcc-contact-note-${mergeRequestIid}.gcrm.sehlat.io/remoteEntry.js`;
    }
    case 'TST50': {
      return 'https://pcc-fe-contactnote-tst50.juliusbaer.com/remoteEntry.js';
    }
    case 'TST60': {
      return 'https://pcc-fe-contactnote-tst60.juliusbaer.com/remoteEntry.js';
    }
    case 'UAT1': {
      return 'https://pcc-fe-contactnote-uat1.juliusbaer.com/remoteEntry.js';
    }
    case 'UAT2': {
      return 'https://pcc-fe-contactnote-uat2.juliusbaer.com/remoteEntry.js';
    }
    case 'UAT10': {
      return 'https://pcc-fe-contactnote-uat10.juliusbaer.com/remoteEntry.js';
    }
    case 'PRD': {
      return 'https://pcc-fe-contactnote.juliusbaer.com/remoteEntry.js';
    }
    case 'PRD2': {
      return 'https://pcc-fe-contactnote-prd2.juliusbaer.com/remoteEntry.js';
    }
    default: {
      throw new Error(`Unknown environment: ${env}`);
    }
  }
};
